<div class="background">
    <div class="container">
        <svg class="logo-bg" viewBox="0 0 646 820" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g style="mix-blend-mode:soft-light">
                <path
                    d="M116.512 750.288C110.525 754.781 105.286 763.393 103.415 767.138C264.316 817.686 348.508 785.86 417.732 750.288C594.349 642.451 601.084 450.741 582.375 368.366C561.795 403.937 528.118 453.821 490.699 452.613C444.3 451.116 404.012 428.275 389.668 417.042C389.668 403.937 440.184 321.561 477.602 315.945C511.279 317.817 548.698 329.05 574.891 336.539C556.182 287.862 546.827 250.419 457.022 201.742C385.178 162.801 263.692 158.058 211.929 160.555C225.65 139.961 258.329 92.0332 279.283 65.0739C451.409 76.307 644.116 226.081 645.987 461.974C647.858 697.868 451.409 870.108 251.219 871.98C91.0668 873.478 -15.0777 791.476 -48.131 750.288C-91.1625 707.228 -160.387 624.853 -166 465.719C-166 281.246 -33.1635 194.254 7.99716 162.427C40.9257 136.965 97.8022 110.63 122.124 100.645C116.512 117.495 112.77 121.239 103.415 134.344C95.9312 147.449 11.739 218.592 -6.97034 235.441C-25.6797 252.291 -64.9694 293.479 -66.8403 299.095C-5.47359 278.127 41.0504 299.095 56.6415 312.2C68.4908 322.809 94.4345 345.9 103.415 353.388C112.395 360.877 114.641 368.99 114.641 372.11V385.215C69.7381 359.005 17.9749 332.794 0.513412 334.666C-41.3956 339.159 -90.5389 380.222 -109.872 400.192V409.553C-103.635 414.545 -84.4271 428.649 -57.4856 445.124C-23.8088 465.718 -6.97034 469.462 9.8681 469.462C54.7706 461.974 93.4366 431.395 107.157 417.042L64.1253 521.883C58.5125 534.988 58.5125 540.605 45.4159 557.455C34.1903 566.815 24.8356 578.048 19.2228 585.537C3.78755 606.131 -1.98117 643.574 -3.22845 662.296C-3.22845 662.296 -3.22845 688.507 0.513412 707.228L9.8681 716.589C9.8681 682.89 32.3194 658.552 45.4159 649.191C55.8932 641.702 63.5016 629.845 65.9962 624.853C71.9832 618.862 73.48 589.281 75.3509 576.176L95.9312 486.312L133.35 572.432C143.328 595.522 163.285 646.195 163.285 664.168C163.285 686.634 153.93 705.356 146.447 720.333C135.221 737.183 123.995 744.672 116.512 750.288Z"
                    fill="white" />
                <path
                    d="M157.672 377.727C192.097 379.224 213.177 407.057 219.413 420.786C187.981 425.28 165.156 423.907 157.672 422.659C140.834 418.914 135.221 385.215 157.672 377.727Z"
                    fill="white" />
                <path
                    d="M370.959 387.087C363.475 388.585 345.389 407.681 337.282 417.042C344.142 420.162 358.611 426.029 361.604 424.531C364.598 423.033 367.841 418.914 369.088 417.042C372.83 406.433 378.443 385.59 370.959 387.087Z"
                    fill="white" />
                <path
                    d="M268.057 267.268C302.483 289.734 354.744 316.569 376.572 327.178C359.733 300.968 322.315 244.802 239.993 242.93C174.136 241.432 136.468 295.975 125.866 323.434L174.511 293.479C208.187 272.885 230.639 250.419 268.057 267.268Z"
                    fill="white" />
                <path
                    d="M95.9312 256.035C76.4735 263.524 66.6199 256.659 64.1253 252.291V246.674C88.4475 207.983 139.337 125.732 148.317 106.262C159.543 81.9233 150.188 76.3068 144.576 76.3068C71.609 80.0511 -55.6147 76.3068 -78.0659 63.2016C-96.0269 52.7175 -85.5497 -9.81307 -78.0659 -39.7678C-23.8088 -17.3018 0.513412 -22.9183 52.8997 -22.9183C120.253 -24.7904 183.242 -37.2715 217.542 -45.3842C233.133 -50.3766 267.683 -57.3661 281.154 -45.3842C294.625 -33.4023 283.025 -0.452065 275.541 14.5253C220.037 89.4122 106.408 242.556 95.9312 256.035Z"
                    fill="white" />
                <path
                    d="M277.412 563.071L226.897 596.77C226.897 597.394 227.271 599.391 228.768 602.387C264.316 600.515 292.38 591.154 309.218 587.41C326.056 583.665 331.669 591.154 335.411 594.898C338.405 597.894 346.637 614.868 350.379 622.981C352.25 620.485 355.992 614.369 355.992 609.876C352.998 593.401 353.497 578.049 354.121 572.432C354.121 563.445 360.001 548.094 367.217 531.244C371.226 521.884 362.852 515.643 357.862 514.395C341.024 516.267 335.037 521.884 318.573 521.884C297.992 521.884 283.025 508.778 268.057 503.162C256.083 498.669 240.617 513.771 234.381 521.884C235.628 524.38 239.619 531.244 245.606 538.733C251.593 546.222 269.305 558.079 277.412 563.071Z"
                    fill="white" />
            </g>
        </svg>

        <div class="intro">
            <h3>Bem vindo(a) ao Protocolo Verde</h3>
            <h1>Grãos do Pará</h1>
            <h2>Parcerias entre Traders e Empresas Auditoras</h2>
        </div>

        <mat-card class="mat-elevation-z6">
            <div class="form-logo">
                <img src="../../../../assets/images/graosdopara/logo.png" alt="Protocolo Verde dos Grãos">
            </div>

            @if(!isConfirmingEmail && !isCorrectingPassword && !isConfirmedPassword && !doubleAuthentication){
            <form [formGroup]="loginForm">
                <div class="login-label">
                    <span> Usuário </span>
                </div>

                <div class="user-input-box">
                    <input class="login-input"
                        [ngStyle]="{border: incorrectPassword ? 'solid 2px #af2b0b' : 'solid 2px #ffffff'}"
                        formControlName="username" placeholder="Usuário" type="text">
                </div>

                <div class="login-label">
                    <span> Senha </span>
                </div>

                <div class="padlock-input-box">
                    <input class="login-input"
                        [ngStyle]="{border: incorrectPassword ? 'solid 2px #ff0000' : 'solid 2px #ffffff'}"
                        formControlName="password" placeholder="Senha" type="password">
                </div>
                <a class="forget-password" (click)="handleForgetPassword()"> <span> Esqueci minha senha </span> </a>
            </form>


            <div class="card-footer">
                <button type="button" (click)="submitForm()"> Entrar </button>
            </div>
            }

            @if(doubleAuthentication){
              <form [formGroup]="doubleAuthenticationForm">
                <div class="login-label">
                    <span> Código </span>
                </div>

                <div class="padlock-input-box">
                  <input
                    class="login-input"
                    formControlName="code"
                    type="text"
                    placeholder="Digite o código recebido via email"
                  >
                </div>
                @if(!timeExpired) {
                  <app-countdown (countdownFinished)="onCountdownFinished()"></app-countdown>
                }
                @if (doubleAuthenticationForm.get('code')?.touched && !doubleAuthenticationForm.get('code')?.value) {
                  <div class="warning">
                    <i class="material-icons notranslate v-align"> report_problem </i>
                    <p style="color: white;">Informe o código antes de enviar!</p>
                  </div>
                }
              </form>
              <div class="card-footer">
                <button type="submit" class="button green" (click)="submitDoubleAuthentication()">Enviar</button>
              </div>
            }

            @if(isConfirmingEmail){
            <form [formGroup]="emailForm">
                <div class="spans-container">
                    <span class="title"> Esqueci minha senha</span>
                    <span class="sub-title"> Informe seu e-mail de cadastro para enviarmos as instruções de redefinição
                        de senha. </span>
                </div>

                <div class="login-label">
                    <span> E-mail </span>
                </div>

                <div class="email-input-box">
                    <input class="login-input"
                        [ngStyle]="{border: isIncorrectEmail ? 'solid 2px #af2b0b' : 'solid 2px #ffffff'}"
                        formControlName="email" placeholder="E-mail" type="text">
                </div>

                <div class="status-spans-container">
                    @if(isCodeSent){
                    <span>
                        Código enviado com sucesso! <svg width="24" height="24" viewBox="0 0 18 18" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M7.16251 13.5L2.88751 9.225L3.95626 8.15625L7.16251 11.3625L14.0438 4.48125L15.1125 5.55L7.16251 13.5Z"
                                fill="#00E600" />
                        </svg>
                    </span>
                    }
                    @if(isIncorrectEmail){
                    <span>
                        E-mail não cadastrado! <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M4.44001 4.44C4.72126 4.1591 5.10251 4.00132 5.50001 4.00132C5.89751 4.00132 6.27876 4.1591 6.56001 4.44L12 9.878L17.44 4.44C17.5792 4.3008 17.7445 4.19038 17.9263 4.11504C18.1082 4.03971 18.3032 4.00093 18.5 4.00093C18.6969 4.00093 18.8918 4.03971 19.0737 4.11504C19.2556 4.19038 19.4208 4.3008 19.56 4.44C19.6992 4.5792 19.8096 4.74446 19.885 4.92633C19.9603 5.10821 19.9991 5.30314 19.9991 5.5C19.9991 5.69686 19.9603 5.89179 19.885 6.07367C19.8096 6.25554 19.6992 6.4208 19.56 6.56L14.122 12L19.56 17.44C19.8411 17.7211 19.9991 18.1024 19.9991 18.5C19.9991 18.8976 19.8411 19.2789 19.56 19.56C19.2789 19.8411 18.8976 19.9991 18.5 19.9991C18.1024 19.9991 17.7211 19.8411 17.44 19.56L12 14.122L6.56001 19.56C6.27888 19.8411 5.89759 19.9991 5.50001 19.9991C5.10244 19.9991 4.72114 19.8411 4.44001 19.56C4.15888 19.2789 4.00095 18.8976 4.00095 18.5C4.00095 18.1024 4.15888 17.7211 4.44001 17.44L9.87801 12L4.44001 6.56C4.15911 6.27875 4.00133 5.8975 4.00133 5.5C4.00133 5.1025 4.15911 4.72125 4.44001 4.44Z"
                                fill="#AF2B0B" />
                        </svg>
                    </span>
                    }
                </div>
            </form>

            @if(isConfirmingEmail){
            <div class="card-footer">
                @if(!isCodeSent){
                <button type="button" (click)="submitEmailCode()"> Enviar </button>
                <button type="button" (click)="handleInitialLoginPage()" style="background-color: #69a742; border: #ffffff solid 1px; color: #ffffff;">
                    Cancelar </button>
                }

                <button (click)="handleInitialLoginPage()" *ngIf="isCodeSent" type="button"> Tela de Login </button>
            </div>
            }
            }

            @if(isCorrectingPassword){
            <form [formGroup]="newPasswordForm" style="height: 35%; gap: 7%;">
                <div class="spans-container" style="justify-content: center; gap: 10%;">
                    <span class="title"> Nova Senha</span>
                    <span class="sub-title" style="margin-bottom: 2%;"> Defina sua nova senha </span>
                </div>

                <div class="login-label">
                    <span> Nova Senha </span>
                </div>

                <div class="padlock-input-box">
                    <input class="login-input"
                        [ngStyle]="{border: redInput ? 'solid 2px #af2b0b' : 'solid 2px #ffffff'}"
                        formControlName="newPassword" placeholder="Senha" type="password">
                </div>

                <div class="login-label">
                    <span> Confirmar Nova Senha </span>
                </div>

                <div class="padlock-input-box">
                    <input class="login-input"
                        [ngStyle]="{border: redInput ? 'solid 2px #af2b0b' : 'solid 2px #ffffff'}"
                        formControlName="confirmNewPassword" placeholder="Senha" type="password">
                </div>
            </form>

            <div class="card-footer">
                <div class="password-instructions-container">
                    <span class="password-title"> <i class="material-icons notranslate v-align" style="margin-right: 3px;">
                            report_problem </i> Por motivos de segurança, a nova senha deve conter: </span>
                    <div class="instructions-container">
                        <span class="instruction"> - No mínimo 8 caracteres. </span>
                        <span class="instruction"> - Uma letra maiúscula. </span>
                        <span class="instruction"> - Uma letra mínuscula. </span>
                        <span class="instruction"> - Um número. </span>
                        <span class="instruction"> - Um caractere especial (! , &#64; , - , / , etc). </span>
                    </div>
                </div>

                <button type="button" (click)="submitNewPassword()" style="height: 14.5%; border:#ffffff solid 1px;"> Confirmar </button>
                <button type="button" (click)="handleInitialLoginPage()" style="background-color:#ffffff; border:#69a742 solid 1px; color:#69a742; height: 14.5%;">
                    Cancelar </button>
            </div>
            }

            @if(isConfirmedPassword){
            <div class="card-footer" style="gap: 14%;">
                <span style="font-size: clamp(0.5rem, 24px, 2rem); font-weight: 600; color: #ffffff;"> Senha redefinida
                    com sucesso! </span>
                <button (click)="handleInitialLoginPage()" type="button"> Tela de Login </button>
            </div>
            }
        </mat-card>
    </div>
</div>
